import { createAction, props } from "@ngrx/store";
import { IVesselStop } from "../model/vessel-stop";
import { IQueryResult } from "@pmis3/data-access";
import { IDateTimeRange } from "@pmis3/utils";

export enum VesselStopActionTypes {
    LoadVesselStops = "[VesselVisit Page] Load VesselStops",
    LoadVesselStopsByDateRange = "[VesselVisit Page] Load VesselStops by DateRange",
    LoadVesselStopsSuccess = "[VesselVisit Page] Load VesselStops Success",
    LoadVesselStopsFail = "[VesselVisit Page] Load VesselStops Fail"
}

export const LoadVesselStops = createAction(
  VesselStopActionTypes.LoadVesselStops
)

export const LoadVesselStopsByDateRange = createAction(
  VesselStopActionTypes.LoadVesselStopsByDateRange,
  props<{dateRange: IDateTimeRange}>()
);

export const LoadVesselStopsSuccess = createAction(
  VesselStopActionTypes.LoadVesselStopsSuccess,
  props<{result: IQueryResult<IVesselStop>}>()
);

export const LoadVesselStopsFail = createAction(
  VesselStopActionTypes.LoadVesselStopsFail,
  props<{ error: string }>()
);